import {ReactElement, useEffect, useState} from "react";

export type Point = {
    x: number,
    y: number,
}

export type ExportData = {
    style: { fill: string },
    points: Point[],
}

export type Path = {
    counter: number,
    x: number,
    y: number,
    lines: number,
    cols: number,
    points: Point[],
}
export function colorGenerator2(path: Path): string {
    const colors: string [] = ['#1A6F44', '#2CADA0', '#0A4E39', '#34984F', '#0B7E4F', '#238E72', '#1B7E6D', '#218A5F'];
    const index = Math.floor(Math.random() * (colors.length - 1));
    return colors[index];
}

export function Triangular(props: any): ReactElement {
    const {width, height, lineHeight, pointArea, renderingFunction, strokeColor, strokeWidth} = props as {
        width: number,
        height: number,
        lineHeight: number,
        pointArea: number,
        renderingFunction: (path: Path) => string,
        strokeColor: string,
        strokeWidth: number,
    };
    const triangleLine = Math.sqrt(Math.pow(lineHeight / 2, 2) + Math.pow(lineHeight, 2));
    const originX = -triangleLine;
    const originY = -lineHeight;

    const [exportData, setExportData] = useState<ExportData[]>([]);

    const lineMapping = (): Point[][] => {
        var lines: Point[][] = [];
        var x: number;
        var y: number;
        var line: Point[];
        const lineX: number = Math.ceil(width / triangleLine) + 4;
        const lineY: number = Math.ceil(height / lineHeight) + 2;
        var parite: number = triangleLine / 4;
        for (y = 0; y < lineY; y++) {
            line = [];
            for (x = 0; x < lineX; x++) {
                line.push({
                    x: x * triangleLine + Math.round(Math.random() * pointArea * 2) - pointArea + originX + parite,
                    y: y * lineHeight + Math.round(Math.random() * pointArea * 2) - pointArea + originY//INFO: was 'originX'
                });
            }
            lines.push(line);
            parite *= -1;
        }
        return lines;
    };

    const createTriangles = (lines: Point[][]): ExportData[] => {
        var exportData: ExportData[] = [];
        var i: number;
        var parite: boolean;
        var lineA: Point[];
        var lineB: Point[];
        var aIndex: number;
        var bIndex: number;
        var points: Point[];
        var pointsList: Point[];
        var counter: number = 0;
        var lineParite: boolean = true;

        for (i = 0; i < lines.length - 1; i++) {
            lineA = lines[i];
            lineB = lines[i + 1];
            aIndex = 0;
            bIndex = 0;
            parite = lineParite;
            do {
                points = [lineA[aIndex], lineB[bIndex]];
                if (parite) {
                    bIndex++;
                    points.push(lineB[bIndex]);
                } else {
                    aIndex++;
                    points.push(lineA[aIndex]);
                }
                parite = !parite;
                pointsList = [points[0], points[1], points[2]];
                exportData.push({
                    style: {
                        fill: renderingFunction({
                            counter: counter,
                            x: aIndex + bIndex - 1,
                            y: i,
                            lines: lines.length,
                            cols: (lineA.length - 2) * 2,
                            points: pointsList
                        })
                    },
                    points: pointsList
                });
                counter++;
            } while (aIndex !== lineA.length - 1 && bIndex !== lineA.length - 1);
            lineParite = !lineParite;
        }
        return exportData;
    };

    useEffect(() => {
        var lines = lineMapping();
        var data = createTriangles(lines);
        setExportData(data);
    }, [width, height, lineHeight, pointArea, renderingFunction]);

    return (
        <svg version={'1.1'} width={'100%'} height={'100%'} viewBox={'0 0 ' + width + ' ' + height}
             enableBackground={'new 0 0 ' + width + ' ' + height} paintOrder={'fill'}
             preserveAspectRatio={'xMinYMin slice'}>
            {exportData.map((data, i) =>
                <path key={i} stroke={strokeColor} strokeWidth={strokeWidth} strokeMiterlimit={strokeWidth}
                      strokeLinecap={"round"} strokeLinejoin={"round"}
                      fill={data.style.fill} shapeRendering={'geometricPrecision'}
                      d={'M' + data.points[0].x + ' ' + data.points[0].y + ' '
                          + 'L' + data.points[1].x + ' ' + data.points[1].y + ' '
                          + 'L' + data.points[2].x + ' ' + data.points[2].y + ' Z'}
                />
            )}
        </svg>)
}
